import React, { useContext, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import ExpandValidityList from '../ExpandValidityList/ExpandValidityList';
import { getExpandValidity } from 'src/redux/expand_validity/thunks';
import { loadProspectCatalogs } from 'src/redux/prospects/prospects.thunks';
import Pagination from 'src/components/common/pagination';
import { TabBarContext } from 'src/components/common/TabSwich';

const ExpandValidity = () => {
    const { pagination } = useAppSelector((state) => state.UI);
    const dispatch = useAppDispatch();
    const [initialized, setInitialized] = useState(false);
    const { activeTab } = useContext(TabBarContext);

    useEffect(() => {
        if (initialized) {
            dispatch(loadProspectCatalogs());
            dispatch(getExpandValidity({ page: 1, selectedTab: activeTab }));
            return;
        }
        setInitialized(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialized]);

    const onChangePageHandler = (page: number) => {
        dispatch(getExpandValidity({ page, selectedTab: activeTab }));
    };

    return (
        <>
            {/* <SearchBarRetention /> */}
            <ExpandValidityList />
            <Pagination paginate={pagination} onChangePage={onChangePageHandler} />
        </>
    );
};

export default ExpandValidity;
